import GeneratedDocumentServiceApi from "./generated/GeneratedDocumentServiceApi"

class DocumentServiceApi extends GeneratedDocumentServiceApi {

}

export const documentServiceApi = new DocumentServiceApi()
